import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-066f084f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "week-day-cell"
}

import { locale } from "../../constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'week-days-header',
  props: {
  /**Показать заголовок для номера недели */
  showWeekNumTitle: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const daysList = [1, 2, 3, 4, 5, 6, 0];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['week-days-header', { 'show-week-num': __props.showWeekNumTitle }])
  }, [
    (__props.showWeekNumTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Нед."))
      : _createCommentVNode("", true),
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(daysList, (dayIndex) => {
      return _createElementVNode("div", {
        class: _normalizeClass([
        'week-day-cell',
        { 'is-weekend': dayIndex === 0 || dayIndex === 6 },
      ])
      }, _toDisplayString(_unref(locale).weekDayShortNames[dayIndex]), 3)
    }), 64))
  ], 2))
}
}

})